import FieldConfig from "./FieldConfig";
export default FieldConfig;
